import { Paper, styled } from '@mui/material';
import moment, { duration } from 'moment';
import { colors } from './properties';
import 'moment-timezone';
import { Cookies } from 'react-cookie';

export function getDropDownItems(input) {
  let items = [];

  input.map((item) => {
    items.push({ label: item.name, key: item.id });
  });
  return items;
}

export function getGroupDropDownItems(input) {
  let items = [];
  input.map((item) => {
    if (item.status) {
      items.push({ label: item.name, key: item.id });
    }
  });
  return items;
}

export function getMemberGroupDropDownItems(input) {
  let items = [];

  input.map((item) => {
    const payableAmount = item?.groupFeeAmount - item?.memberTotalPaidAmount;
    if (payableAmount > 0) {
      items.push({
        label: item?.groupName,
        key: item?.groupFeeId
      });
    }
  });

  return items;
}

export function getMemberGroupFeeDropDownItems(input) {
  let items = [];

  input.map((item) => {
    const payableAmount = item?.groupFeeAmount - item?.memberTotalPaidAmount;
    if (payableAmount > 0) {
      items.push({
        label: item?.groupName,
        key: item?.groupFeeId
      });
    }
  });
  return items;
}

export function getTimeFormat(dateValue: Date, formatType: string) {
  var now = moment();

  if (formatType === 'datetime') {
    return moment(dateValue).local().format('YYYY-MM-DD HH:MM');
  } else if (formatType === 'date') {
    return moment(dateValue).local().format('YYYY-MM-DD');
  } else if (formatType === 'time') {
    return moment(dateValue).local().format('HH:MM');
  } else if (formatType === 'timeWithSec') {
    return moment(dateValue).format('hh:mm:ss');
  } else if (formatType === 'currentDateTime') {
    return moment(now).local().format('YYYY-MM-DD hh:mm:ss');
  } else if (formatType === 'currentDate') {
    return moment(now).local().format('YYYY-MM-DD');
  } else if (formatType === 'currentTime') {
    return moment(now).local().format('hh:mm:ss');
  }
}

export function addTwoTimes(time1: Date, time2: string) {
  const time1Formatted = moment(time1).format('hh:mm:ss');
  const time1Duration = duration(time1Formatted);
  const time2Formatted = duration(time2);

  const result = time1Duration.add(time2Formatted);
  const formattedResult = moment
    .utc(result.asMilliseconds())
    .format('HH:mm:ss');
  return formattedResult;
}

export function subtractTwoTimes(time1: Date, time2: string) {
  const time1Formatted = moment(time1).format('hh:mm:ss');
  const time1Duration = duration(time1Formatted);
  const time2Formatted = duration(time2);
  const result = time1Duration.subtract(time2Formatted);
  const utcResult = moment.utc(result.asMilliseconds());
  const formattedResult = utcResult.format('HH:mm:ss');
  return formattedResult;
}

export function getLocalTime(dateValue: string) {
  const time2Formatted = duration(dateValue);

  const utcResult = moment.utc(time2Formatted.asMilliseconds());
  const localResult = utcResult.local();

  const formattedResult = localResult.format('HH:mm:ss');
  return formattedResult;
}

export function styleItem() {
  return styled(Paper)(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === 'dark' ? colors.BLACK_PEARLS : colors.WHITE,
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.primary,
    borderRadius: 0
  }));
}

export function getWordStr(str) {
  return str.split(/\s+/).slice(0, 15).join(' ');
}

export function getCountOfWords(paragraph) {
  return paragraph.split(' ').length;
}

export function getParagraphSentenceCount(paragraph) {
  const sentenceBreak = paragraph?.split('.');

  return sentenceBreak?.length;
}

export function getLimitedSentences(paragraph, numberOfSentences) {
  if (!paragraph || typeof paragraph !== 'string') {
    return 'Invalid input';
  }

  const sentenceBreak = paragraph.split('.');

  let requiredSentences = '';

  for (let i = 0; i < numberOfSentences && i < sentenceBreak.length; i++) {
    requiredSentences += sentenceBreak[i].trim() + '. ';
  }

  return requiredSentences.trim();
}

export const getProgressBarValue = (
  noOfTotalActivities: number,
  noOfCompletedActivities: number
) =>
  noOfTotalActivities === 0
    ? 0
    : (noOfCompletedActivities / noOfTotalActivities) * 100;

export function removeProperty(arr, propToRemove) {
  return arr.map((obj) => {
    let newObj = { ...obj };
    delete newObj[propToRemove];
    return newObj;
  });
}

export const retrieveLoggedInParentData = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(JSON.parse(localStorage.getItem('loggedInUser')));
    });
  });
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const setLocalStorageData = (data) => {
  localStorage.setItem(
    'loggedInUser',
    JSON.stringify({
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      profile: data.profile,
      userType: data.userType,
      parentId: data.parentId,
      isFirstTimeLogin: data.isFirstTimeLogin,
      country: {
        id: data.country?.id,
        name: data.country?.niceName
      }
    })
  );
};

const clearUserData = () => {
  const cookies = new Cookies();
  const domain = process.env.REACT_APP_COOKIE_DOMAIN;
  cookies.remove('logged_in', {
    path: '/',
    domain: process.env.REACT_APP_COOKIE_DOMAIN
  });
  cookies.remove('access_token', {
    path: '/',
    domain: process.env.REACT_APP_COOKIE_DOMAIN
  });
  cookies.remove('refresh_token', {
    path: '/',
    domain: process.env.REACT_APP_COOKIE_DOMAIN
  });
  cookies.remove('logged_in_type', {
    path: '/',
    domain: process.env.REACT_APP_COOKIE_DOMAIN
  });
  cookies.remove('hs_token', {
    path: '/',
    domain: process.env.REACT_APP_COOKIE_DOMAIN
  });
  document.cookie = `logged_in=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  document.cookie = `access_token=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  document.cookie = `refresh_token=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  document.cookie = `logged_in_type=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  localStorage.clear();
};

export { clearUserData };
